import script from "./NationalIdNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalIdNumber.vue?vue&type=script&setup=true&lang=js"

import "./NationalIdNumber.vue?vue&type=style&index=0&id=49d8fb5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d8fb5f"]])

export default __exports__